export enum WebViewType {
  None = 0,
  Facebook = 1,
  Instagram = 2
}
